module.exports = __webpack_public_path__ + "static/media/animaven.e2f1f352.png";